export default {
  header: {
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse'
  },
  userMenu: {
    wallet: 'Cartera',
    withdraw: 'Retirar',
    transaction: 'Transacción',
    myBet: 'Mis Apuestas',
    rollover: 'Rollover',
    vault: 'Bóveda',
    profile: 'Perfil',
    settings: 'Configuración',
    signOut: 'Cerrar Sesión',
    signOutTitle: 'Cerrar sesión',
    signOutContent: '¡Explora un mundo lleno de recompensas y juegos emocionantes!',
    signOutConfirm: 'Cerrar sesión',
    cancel: 'Cancelar'
  }
};
